// extracted by mini-css-extract-plugin
export default {"paymentWalletStubs":"payment-wallet-stubs_paymentWalletStubs__560f1"};